import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Subject } from 'rxjs';
import { FuseConfigService } from '../../../../@fuse/services/config/config.service';
import { fuseAnimations } from '../../../../@fuse/animations';
import { ResetPasswordModel } from '../authentication.model';
import { AuthenticationService } from '../authentication.service';
import { AppRoute } from '../../../shared/app.routes';
import { NotificationService } from '../../../shared/services/notification.service';
import { ValidationService } from "../../../shared/services/validation.service";
import { FuseAlertService } from '@fuse/components/alert';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.scss'],
  animations: fuseAnimations
})

export class ResetPasswordComponent implements OnInit, OnDestroy {
  formResetPassword: FormGroup;
  notificationService: NotificationService;
  isSubmitBtnDisabled: boolean = false;
  linkExpired: boolean;
  email: string;
  code: string;
  isSet:boolean=false;
  apiResponseErrorMessage: string = null;

  private unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    private router: Router,
    private snb: MatSnackBar,
    private fuseConfigService: FuseConfigService,
    private formBuilder: FormBuilder,
    public fuseAlertService: FuseAlertService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
  ) {

    this.notificationService = new NotificationService(snb);

    this.unsubscribeAll = new Subject();
    // Configure the layout
    this.fuseConfigService.config={
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.formResetPassword = this.formBuilder.group({
      'password': ['', [Validators.required, ValidationService.passwordValidator]],
      'confirmPassword': ['', [Validators.required]]
    });
    this.route.queryParams.subscribe(params => {
      this.email = params['email'];
      this.code = params['code'];
      var isSet = params["isSet"];
      this.isSet = isSet === "true";
    });
    if (this.email && this.code) {
      this.spinner.show();
      this.authenticationService.doResetPassword(this.email, this.code).subscribe(result => {
        this.spinner.hide();
        if (result.status === 1)
          this.linkExpired = false;
        else
        this.linkExpired = true;
      });
    }
  }

  /**Form submit method **/
  resetPassword() {
    this.apiResponseErrorMessage = null;
    let model: ResetPasswordModel = new ResetPasswordModel();
    model.email = this.email;
    model.code = this.code;
    model.password = this.formResetPassword.value.password;
    if (this.formResetPassword.dirty && this.formResetPassword.valid) {
      this.spinner.show();
      this.isSubmitBtnDisabled = true;
      this.authenticationService.doSetPassword(model).subscribe(result => {
        this.isSubmitBtnDisabled = false;
        if (result.status === 1) {
          this.spinner.hide();
          this.fuseAlertService.show(result.message, result.status);
         // this.notificationService.showNotification(result.message);
          this.router.navigateByUrl(AppRoute.loginAdmin);
        }
        else if (result.status === 0) {
          this.spinner.hide();
          this.apiResponseErrorMessage = result.message;
        }
      });
    };
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.unsubscribeAll.next('');
    this.unsubscribeAll.complete();
  }


}
